/**
 * M6 — check-in. A remembered person it has been too long with, and how
 * long. Row or card by density. The primary tap is `open` — the host's
 * route map asks f8 for help (prefills the composer, never sends); "not now"
 * is the 14-day dismiss the server honours. One at a time, with a reason —
 * the module most likely to feel like nagging, so the dismiss is real.
 */

import { User } from 'react-feather';
import { HomeAction, HomeActions, HomeCard, HomeGlyph, HomeRow } from '../HomeKit';
import { sinceLabel } from '../format';
import type { ModuleProps } from '../moduleTypes';

export function CheckinModule({ module, onAction }: ModuleProps) {
  if (module.type !== 'checkin') return null;
  const { payload } = module;
  const act = (a: Parameters<NonNullable<typeof onAction>>[0]) => onAction?.(a, module);

  const body = `It’s been ${sinceLabel(payload.sinceDays)} since ${payload.personName}`;
  const sub = 'ask f8 to help you check in';
  const help = () => act({ kind: 'open' });
  const dismiss = module.dismissable ? () => act({ kind: 'dismiss', dismissKey: module.dismissKey }) : undefined;

  if (module.density === 'row') {
    return (
      <HomeRow
        reason={module.reason}
        body={body}
        sub={sub}
        glyph={
          <HomeGlyph tone="violet">
            <User size={14} />
          </HomeGlyph>
        }
        dismissable={module.dismissable}
        onDismiss={dismiss}
        onOpen={help}
      />
    );
  }

  return (
    <HomeCard
      reason={module.reason}
      body={body}
      sub={sub}
      dismissable={module.dismissable}
      onDismiss={dismiss}
      onOpen={help}
      secondary={
        <HomeActions>
          <HomeAction primary onClick={help}>help me check in</HomeAction>
          {dismiss ? <HomeAction onClick={dismiss}>not now</HomeAction> : null}
        </HomeActions>
      }
    />
  );
}
